import React, { FC } from "react";

import { startOfMonth, endOfMonth } from "date-fns";

import {
  useApisPartnerConsolesCompaniesAnalyticsCumulativeRankingsIndex,
  useDateRange,
  usePartnerConsolesMultiDivisionMultiSectionDropdown,
  usePartnerConsolesCompaniesDropdown,
} from "~/hooks";

import { PartnerConsoleLayout } from "~/components/layouts";
import { AnalyticsCumulativeRankingsTemplate } from "~/components/templates";

import { LabelWithDropDownField } from "~/ui";

const today = new Date();

export const PartnerConsolesAnalyticsCumulativeRankingsIndex: FC = () => {
  const query = new URLSearchParams(location.search);
  const companyId = query.get("company_id") || "";
  const breadCrumbItems = [
    {
      label: "パートナー画面",
      href: "/partner_consoles",
    },
    {
      label: "累計ランキング",
      href: "/partner_consoles/analytics",
    },
  ];

  const [{ onChangeCompany, dropdownSelectableValue, dropdownValue, company }] =
    usePartnerConsolesCompaniesDropdown({
      defaultCompanyId: companyId,
    });

  const {
    selectableDivisions,
    selectedDivisions,
    onDivisionChange,
    optionSelectableSections,
    optionSelectedSections,
    onSectionChange,
  } = usePartnerConsolesMultiDivisionMultiSectionDropdown({
    companyId: company?.id || "",
  });

  const [
    {
      startDate,
      formattedStartDate,
      endDate,
      formattedEndDate,
      onChange: onChangeDateRange,
    },
  ] = useDateRange([startOfMonth(today), endOfMonth(today)]);

  const { isLoading, data } =
    useApisPartnerConsolesCompaniesAnalyticsCumulativeRankingsIndex({
      companyId: company?.id || "",
      params: {
        businessDivisionIds: selectedDivisions.map((division) => division.id),
        businessSectionIds: optionSelectedSections.map((section) => section.id),
        fromDate: formattedStartDate || undefined,
        toDate: formattedEndDate || undefined,
      },
      config: {
        enabled: !!(formattedStartDate && formattedEndDate && company),
      },
    });

  return (
    <>
      <PartnerConsoleLayout
        breadCrumbItems={breadCrumbItems}
        companyId={company?.id}
      >
        <LabelWithDropDownField
          required
          labelText="会社"
          name="company"
          options={dropdownSelectableValue}
          value={dropdownValue}
          onChange={onChangeCompany}
        />
        <AnalyticsCumulativeRankingsTemplate
          formattedStartDate={formattedStartDate}
          formattedEndDate={formattedEndDate}
          selectedDivisions={selectedDivisions}
          optionSelectedSections={optionSelectedSections}
          data={data}
          className="mt-8"
          isLoading={isLoading}
          onChangeDateRange={onChangeDateRange}
          onDivisionChange={onDivisionChange}
          onSectionChange={onSectionChange}
          selectableDivisions={selectableDivisions}
          optionSelectableSections={optionSelectableSections}
          startDate={startDate}
          endDate={endDate}
          selectedDropdownSections={optionSelectedSections}
        />
      </PartnerConsoleLayout>
    </>
  );
};
